import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { Link } from 'react-router-dom';

const ExtendedSearchSmartSearchTab = (props) => {
  const { eventId, startNumber, codeFactorFromUrl } = props;

  return (
    <div>
      <div>
        <FormattedMessageWrappedInSpan
          id="extendedSearchSmartSearchTab.beforeSearch.title"
          defaultMessage="Show me similar photos"
          className="typography uppercase typography-title_medium mt-10 mb-10"
        />
        <p>
          <FormattedMessageWrappedInSpan
            id="extendedSearchSmartSearchTab.beforeSearch.subtitle"
            defaultMessage="We will show you photos, where you might be on."
          />
        </p>
        <Link
          to={
            codeFactorFromUrl
              ? `/event/${eventId}/smartsearch/${startNumber}/${codeFactorFromUrl}`
              : `/event/${eventId}/smartsearch/${startNumber}`
          }
          replace={true}
        >
          <button className="btn btn-default primary-new full-width">
            <FormattedMessageWrappedInSpan
              id="extendedSearchSmartSearchTab.searchButton"
              defaultMessage="Go"
            />
          </button>
        </Link>
      </div>
    </div>
  );
};

ExtendedSearchSmartSearchTab.defaultProps = {
  codeFactorFromUrl: null,
};

ExtendedSearchSmartSearchTab.propTypes = {
  eventId: PropTypes.number,
  startNumber: PropTypes.string,
};

export default ExtendedSearchSmartSearchTab;
